// extracted by mini-css-extract-plugin
module.exports = {"scroll":"styles_scroll__2F4rs","table":"styles_table__CBLGt","wrap":"styles_wrap__389MN"};